import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Fechar Período", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = {
  class: "ant-col ant-col-xs-23 ant-col-xl-23",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_14 = { style: {"font-size":"18px","font-family":"'Poppins'","font-weight":"300"} }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "PERÍODO:", -1)
const _hoisted_16 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    footer: null,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 800,
    centered: "",
    "wrap-class-name": _ctx.telaBase.apresentarEmpresas?'scroll-modal ss-modal-financeiro':'ss-modal-financeiro'
  }, {
    title: _withCtx(() => [
      _createTextVNode("Controle de Períodos - Movimentação na Conta")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_form_item, {
                    label: "Empresa",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_empresa, {
                        codigoSelecionado: _ctx.state.fechamentoPeriodo.codigoEmpresa,
                        "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.fechamentoPeriodo.codigoEmpresa) = $event)),
                        empresasEspecificas: _ctx.telaBase.empresasDisponiveis
                      }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_selecionar_conta, {
                    codigoSelecionado: _ctx.state.fechamentoPeriodo.codigoConta,
                    "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.fechamentoPeriodo.codigoConta) = $event)),
                    empresas: [_ctx.state.fechamentoPeriodo.codigoEmpresa],
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscarFechamentosPeriodoConta()))
                  }, null, 8, ["codigoSelecionado", "empresas"])
                ])
              ])
            ]),
            _: 1
          }),
          ((_ctx.state.fechamentoPeriodo.codigoConta > 0))
            ? (_openBlock(), _createBlock(_component_a_collapse, {
                key: 0,
                ghost: "",
                class: "ss-accordion"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    key: "1",
                    header: "NOVO FECHAMENTO"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_a_form_item, {
                            label: "Data Inicial e Final",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data_inicial_final, {
                                horaMinutoSegundo: true,
                                dataInicialSelecionada: _ctx.state.fechamentoPeriodo.dataInicial,
                                "onUpdate:dataInicialSelecionada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.fechamentoPeriodo.dataInicial) = $event)),
                                dataFinalSelecionada: _ctx.state.fechamentoPeriodo.dataFinal,
                                "onUpdate:dataFinalSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.fechamentoPeriodo.dataFinal) = $event))
                              }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Detalhes",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("textarea", {
                                rows: 3,
                                class: "ant-input",
                                placeholder: "Descreva se você achar necessário informações ou um motivo para este fechamento",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.fechamentoPeriodo.detalhes) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.fechamentoPeriodo.detalhes]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque ss-tamanho-completo",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fecharPeriodoMovimento()))
                      }, _hoisted_10)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_skeleton, {
            loading: _ctx.telaBase.carregando
          }, {
            default: _withCtx(() => [
              (_ctx.state.listaFechamentosPeriodos.length <= 0)
                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                    key: 0,
                    mensagem: "Nenhum fechamento de Período foi encontrado."
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_a_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Fechamentos da Conta")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaFechamentosPeriodos, (fechamentoPeriodo, index) => {
                      return (_openBlock(), _createBlock(_component_card, { key: index }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(fechamentoPeriodo.dataInicial )) + " a " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(fechamentoPeriodo.dataFinal )), 1)
                              ]),
                              (_ctx.UtilitarioGeral.valorValido(fechamentoPeriodo.detalhes))
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 0,
                                    placement: "top",
                                    title: fechamentoPeriodo.detalhes
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_tag, { color: "blue" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Detalhes")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.confirmarExclusao(fechamentoPeriodo)),
                                type: "button",
                                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao"
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_17)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_a_alert, {
            message: "Os fechamentos bloqueiam novas movimentações em Contas que você já consolidou ou concluiu sua auditoria.",
            type: "info",
            "show-icon": ""
          })
        ]),
        _: 1
      }),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}